export default __webpack_public_path__ + "static/0227-7abcea99768038b1b81514249b84f367.png";